<template>
  <div class="reject-product-applicant" v-if="applicant"> 

    <!-- 面包屑导航 -->
    <div class="bread">
      <router-link class="bread-item" to="/">上上签</router-link>
      <div class="bread-arrow">&gt;</div>
      <router-link class="bread-item" :to="'/orders'">订单管理</router-link>
      <div class="bread-arrow">&gt;</div>
      <div class="bread-item bread-ellipsis">{{ queryParams.isReUpload ? '查看原因' : '申请赔付' }}</div>
    </div>

    <div class="reject-applicant-info">
      <div class="back-icon" @click="goBack()">
        <i class="el-icon-arrow-left"></i>
        返回
      </div>
      <div class="applicnat-info">
        <span class="applicant-name" :title="applicant.applicant_name">{{ applicant.applicant_name }}</span>
        <span class="applicant-identify">{{ applicantIdentify ? applicantIdentify : '通用身份' }}</span>
      </div>
      <!-- 0待上传 1等待审核 2审核不通过 3审核通过 4超时未提交 -->
      <el-button class="el-button el-button--primary submit-btn" @click="submit" v-if="applicant.file_status === 0" :disabled="!applicant.file_set || applicant.file_set.length <= 0">提交</el-button>
      <el-button class="el-button el-button--primary submit-btn" @click="reverify" v-if="applicant.file_status === 2" :disabled="isNeedEditFile">重新审核</el-button>
    </div>

    <div class="reject-img-content">
      <div class="reject-img-text">
        <template v-if="queryParams.isReUpload">
          <span class="text-title">审核失败</span>（若有疑问，可咨询对应的签证专家）
        </template>
        <template v-else>
          <span class="text-title">拒签凭证</span>（请上传拒签文件，审核人员核实确定符合赔付规则，将进行赔付）
        </template>
      </div>
      <div class="upload-img-list">
        <upload-reject-material-list :file-set="applicant.file_set" :applicant="applicant" @updateFileSet="updateFileSet"></upload-reject-material-list>
        <div class="upload-img-tip" v-if="rejectDesc">
          <p class="primary-key">资料要求：</p>
          <div class="tip-text">{{ rejectDesc }}</div>
        </div>
      </div>

      <!-- 0待上传 1等待审核 2审核不通过 3审核通过 4超时未提交 -->
      <div class="reject-reason" v-if="applicant.file_status === 2 && reasonList && reasonList.length">
        <div class="reason-label">不合格原因：</div>
        <div class="reason-item" v-for="(item, index) in reasonList" :key="index">
          <span>{{ index + 1 }}、</span>
          <div class="textarea-text">{{ item }}</div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import UploadRejectMaterialList from './components/upload-reject-material-list/upload-reject-material-list.vue';
import Http from '@/libs/http';
import utils from '@/libs/utils';

export default {
  components: {
    UploadRejectMaterialList,
  },
  data() {
    return {
      queryParams: {
        orderId: +this.$route.params.oid,
        applicantId: +this.$route.params.aid,
        isReUpload: !!this.$route.params.isReUpload, // 是否为查看原因
      },
      applicant: undefined,
      order: undefined,
      reasonList: [], // 审核不通过原因
    };
  },
  created() {
    if (this.queryParams.orderId) {
      this.getOrder();
    }
  },
  computed: {
    // 获取申请人身份
    applicantIdentify() {
      if (!this.order) return;
      const currentApplicant = this.order.applicant.find(item => item.order_applicant_id === this.applicant.applicant_id);
      if (currentApplicant) {
        return currentApplicant.identity;
      }
    },
    // 判断是否有未修改的文件
    isNeedEditFile() {
      if (!this.applicant.file_set || !this.applicant.file_set.length) return false;
      // 0待上传 1等待审核 2审核不通过 3审核通过 4超时未提交
      return !!this.applicant.file_set.find(item => item.status === 2);
    },
    // 获取资料要求
    rejectDesc() {
      if (this.order && this.order.reject_product_set) {
        return this.order.reject_product_set.reject_desc;
      }
    },
  },
  methods: {
    // 获取订单详情
    getOrder() {
      return Http.post('/order_query', { user_order_id: this.queryParams.orderId }).then((data) => {
        
        if (this.queryParams.applicantId && data.reject_product_set && data.reject_product_set.applicant_set && data.reject_product_set.applicant_set.length) {
          const applicant = data.reject_product_set.applicant_set.find(item => item.applicant_id === this.queryParams.applicantId);
          if (applicant) {
            this.applicant = applicant;
            // 设置审核不通过原因
            this.reasonList = this.getReasonList();
          }
        }
        this.order = data;
      }).catch((e) => {
        if (e) console.log(e);
      });
    },
    // 获取原因列表
    getReasonList() {
      let reasonList = [];
      // 查找到预审不通过的原因
      if (!this.applicant.file_set) return reasonList;
      // 0待上传 1合格 2不合格 3待审核
      const notPassFileList = this.applicant.file_set.filter(file => file.status && file.status === 2);
      reasonList = notPassFileList.map(file => file.memo);
      return reasonList;
    },
    // 回退
    goBack() {
      history.back();
    },
    // 提交
    submit() {
      const params = {
        applicant_id: this.applicant.applicant_id,
        file_set: this.applicant.file_set.map(file => file.key),
      };
      Http.post('/reject_product_applicant_submit', params).then((res) => {
        utils.msg.success('提交成功');
        this.goBack();
      });
    },

    // 重新审核
    reverify() {
      const params = {
        applicant_id: this.applicant.applicant_id,
      };
      Http.post('/reject_product_applicant_reverify', params).then((res) => {
        utils.msg.success('提交成功');
        this.goBack();
      });
    },

    // 子组件更新父组件内容
    updateFileSet(fileSet) {
      this.applicant.file_set = fileSet || [];
    },

  },
};
</script>

<style lang="less" scoped>
.reject-product-applicant {
  width: 1000px;
  margin: 0 auto;
  margin-bottom: 92px;
  .reject-applicant-info {
    padding: 0 32px;
    height: 76px;
    background: #FBFBFB;
    display: flex;
    align-items: center;
    .back-icon {
      color: #599FFF;
      font-size: 16px;
      display: flex;
      align-items: center;
      cursor: pointer;
      >i {
        font-size: 14px;
        margin-right: 4px;
      }
    }

    .applicnat-info {
      flex: 1;
      padding: 0 40px;
      .applicant-name {
        display: inline-block;
        padding-right: 60px;
        font-size: 22px;
        font-weight: 600;
        color: #2F333D;
      }
      .applicant-identify {
        font-size: 18px;
        color: #5F666E;
      }
    }

    .submit-btn {
      width: 110px;
    }

  }

  .reject-img-content {
    font-size: 14px;
    background-color: #fff;
    padding-bottom: 32px;
    .reject-img-text {
      padding: 0 32px;
      height: 55px;
      line-height: 55px;
      color: #599FFF;
      background: #F2F8FF;
      .text-title {
        font-size: 20px;
        // font-weight: 600;
      }
    }

    .upload-img-list {
      padding: 32px 32px 0 32px;
      .upload-img-tip {
        margin-top: 20px;
        font-size: 14px;
        color: #5F666E;
        .primary-key {
          font-weight: 600;
          margin-bottom: 8px;
        }
        .tip-text {
          white-space: pre-wrap;
        }
      }
    }


    .reject-reason {
      margin: 20px 32px 0 32px;
      padding: 20px;
      background: #FFF7F8;
      border-radius: 2px;
      border: 1px solid rgba(244,69,92,0.3);
      font-size: 14px;
      color: #5F666E;
      .reason-label {
        font-weight: 600;
        color: #F43344;
        margin-bottom: 8px;
      }
      .reason-item {
        line-height: 24px;
        display: flex;
        margin-bottom: 4px;
        color: #5F666E;
        &:last-child {
          margin-bottom: 0;
        }
      }
      .textarea-text {
        white-space: pre-wrap;
      }
    }

  }

}

</style>



// WEBPACK FOOTER //
// src/pages/orders/reject-product-applicant/reject-product-applicant.vue